<template>
  <div class="navuser">
    <languageButton style="color: white; margin-right: 10px"></languageButton>

    <el-dropdown
      @command="handleCommand"
      trigger="click"
      class="user"
      hide-on-click
    >
      <span v-if="user" class="el-dropdown-link">
        <em class="fas fa-user"></em>
        {{ user.name }} {{ user.surname }}
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-if="user" command="admin">{{
          $t("NavUser.admin")
        }}</el-dropdown-item>
        <el-dropdown-item v-if="user" command="resetpassword">{{
          $t("NavUser.resetPassword")
        }}</el-dropdown-item>
        <el-dropdown-item command="logout">{{
          $t("NavUser.logout")
        }}</el-dropdown-item>
        <el-dropdown-item
          command="language"
          divided
          style="text-align: center"
        ></el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog width="30%" :title="$t('forgotpassword.resetyourpassword')" :visible.sync="showResetPasswordForm">
      <!-- <b-modal
      id="reset-password"
      title="Reset password"
      hide-footer
      >-->
      <resetpassword></resetpassword>
      <!-- </b-modal> -->
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import resetpassword from "./ResetPassword";
import languageButton from "./Language";
export default {
  name: "nav-user",
  components: { resetpassword, languageButton },
  data() {
    return {
      showResetPasswordForm: false,
    };
  },
  computed: {
    ...mapState("account", ["user", "customer"]),
  },
  methods: {
    handleCommand(command) {
      switch (command) {
        case "admin":
          this.$router.push("/admin");
          break;
        case "logout":
          this.logout();
          break;
        case "resetpassword":
          this.showResetPasswordForm = true;
          break;
      }
    },
    ...mapActions("account", ["login", "logout"]),
  },
};
</script>

<style scoped>
.navuser {
  color: white;
  display: flex;
  margin-left: auto;
  order: 2;
}
.user {
  margin-right: 30px;
  float: right;
}
.el-dropdown-link {
  cursor: pointer;
  color: white;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>
